module.exports = __webpack_public_path__ + "static/media/img_header_submit_inquiry_mobile.6342831a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/submitInquiry/assets/img_header_submit_inquiry_mobile.jpg
// module id = 1078
// module chunks = 1